const MOBILE_RELEASE = require('./mobileRelease.json');
const PUBLIC_IDENTITY = require('./publicIdentity.json');

// Fail closed: a draft or invalid URL must never become a download button.
function getStoreUrl(platform, release) {
  if (release?.status !== 'released' || typeof release.url !== 'string') return null;
  try {
    const url = new URL(release.url);
    if (url.protocol !== 'https:' || url.username || url.password || url.port || url.hash) return null;
    if (platform === 'ios' && url.hostname === 'apps.apple.com'
      && /^\/(?:[a-z]{2}\/)?app\/(?:[^/]+\/)?id\d+\/?$/.test(url.pathname)) return url.href;
    if (platform === 'android' && url.hostname === 'play.google.com'
      && url.pathname === '/store/apps/details'
      && url.searchParams.getAll('id').length === 1
      && url.searchParams.get('id') === 'ai.noesa.mobile') return url.href;
  } catch { /* Keep the prelaunch state for malformed URLs. */ }
  return null;
}

function getMobileContent(language = 'ru', releases = MOBILE_RELEASE.stores) {
  const locale = language === 'en' ? 'en' : 'ru';
  const copy = MOBILE_RELEASE.locales[locale];
  const stores = ['ios', 'android'].map((platform) => {
    const href = getStoreUrl(platform, releases[platform]);
    return {
      platform, href,
      name: platform === 'ios' ? 'App Store' : 'Google Play',
      device: platform === 'ios' ? copy.iosDevice : copy.androidDevice,
      status: href ? 'released' : 'coming_soon',
      label: href ? copy.storeCta : copy.comingSoon,
      badgeSrc: platform === 'ios' ? `/assets/stores/app-store-${locale}.svg` : null,
      badgeLabel: platform === 'ios' ? copy.appStoreLabel : null,
    };
  });
  const anyReleased = stores.some((store) => store.href);
  return {
    ...copy, stores,
    h1: anyReleased ? copy.h1Available : copy.h1Prelaunch,
    releaseNote: anyReleased ? copy.availableNote : copy.prelaunchNote,
    teaserTitle: anyReleased ? copy.teaserAvailableTitle : copy.teaserPrelaunchTitle,
    updatesUrl: PUBLIC_IDENTITY.socials.telegram,
    supportUrl: `https://api.noesa.ai/legal/mobile/support?lang=${locale}`,
    privacyUrl: `https://api.noesa.ai/legal/mobile/privacy?lang=${locale}`,
    // The route exists in the backend source but is not deployed yet (HTTP 404).
    deletionUrl: MOBILE_RELEASE.accountDeletionPageReady
      ? `https://api.noesa.ai/legal/mobile/account-deletion?lang=${locale}` : null,
  };
}

module.exports = { getStoreUrl, getMobileContent };
